import React, { Component } from "react"
import { connect } from "react-redux"
import { TableHeaderColumn } from "react-bootstrap-table"
import { DckSelectors, DckActionCreators } from "dck-redux"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"

import * as ItemTypes from "../../../redux/items/types"
import { browserHistory, Link } from "react-router"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../lib/Authenticated"
import SingleSelectTable from "../../fragments/SingleSelectTable"
import AlertModal from "../../fragments/AlertModal"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import { blockingFetchService } from "../../../lib/blockingFetch"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import ClearFiltersButton from "../../fragments/ClearFiltersButton"
import { AccountUsage, BooleanStatuses, GLAccountType, sortDate } from "../../../lib/utils"
import UIAvatar from "../../fragments/UIAvatar"

class ListGLAccount extends Component {

  authenticated = new Authenticated()
  isAdminOrAccountant = this.authenticated.isAdmin() || this.authenticated.isAccountant()

  state = {
    glAccount: null,
    running: false,
    success: false,
    error: null,
  }

  componentDidMount() {
    this.props.loadData()
  }

  handleDelete = glAccount => this.setState({ 
    glAccount,
    running: false,
    success: false,
    error: null
  })

  confirmDelete = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { glAccount: { id: glaccountId } } = this.state

    blockingFetchService(
      accessToken => apiServerApi.deleteGLAccount(accessToken, glaccountId),
      _ => {
        this.setState({ success: true })
        this.props.loadData()
        setTimeout(this.closeDeleteForm, 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  closeDeleteForm = () => this.setState({ glAccount: null })

  doClearFilters = () => {
    this.refs.name.cleanFiltered()
    this.refs.glCode.cleanFiltered()
    this.refs.typeFormatted.cleanFiltered()
    this.refs.usageFormatted.cleanFiltered()
    this.refs.createdOnFormatted.cleanFiltered()
    this.refs.disabled.cleanFiltered()
  }

  renderDeletionConfirmContent = () => {

    const { running, success, error } = this.state
    return (
      <div>
        <h3>Are you sure you want to delete this item?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderUpdateLink = id => {

    if(!this.isAdminOrAccountant) return null
    return (
      <Link to={`/glaccounts/${id}/update`} className='p-5'>
        <FontAwesome name="pencil" title='Update' />
      </Link>
    )
  }

  render() {
    const { glAccounts } = this.props,
    { glAccount, running } = this.state

    return (
      <div>
        <CustomBreadCrumb activeText='GL accounts' data={ [{ url: '/accounting', title: 'Accounting' }] } />

        <ClearFiltersButton onClick={ this.doClearFilters } />

        <SingleSelectTable
          items={ glAccounts }
          addNewLabel="Add Account"
          addNewHandler={() => browserHistory.push("/glaccounts/create")}
          handleDelete={ this.handleDelete }
          deleteLabel='Delete'
          disableDelete={() => false}
          exportCSV={ this.isAdminOrAccountant }
          csvFileName='glaccounts.csv'
          shouldRenderToolbar={ this.isAdminOrAccountant }
        >
          <TableHeaderColumn
            dataField="id"
            isKey
            dataAlign="center"
            dataFormat={(_, row) => <UIAvatar name={ row.name } size={ 28 } />}
            csvHeader="GL account ID"
            width='48'
          />

          <TableHeaderColumn
            ref='name'
            dataField="name"
            dataSort
            dataAlign="center"
            filter={{ type: "TextFilter", delay: 1000 }}
            dataFormat={(value, cell) =>
              <Link to={`/glaccounts/${cell.id}/detail`} title='Show details'>
                <span className={ cell.disabled ? 'red' : ''}>{ value }</span>
              </Link>}
            csvHeader="Name"
            columnClassName="min-w-120"
          >
            Name
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='glCode'
            dataField="glCode"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            dataAlign="center"
            csvHeader="GL Code"
            columnClassName="min-w-120"
          >
            GL Code
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='typeFormatted'
            dataField="typeFormatted"
            dataSort
            filter={{ type: "SelectFilter", options: GLAccountType }}
            dataAlign="center"
            csvHeader="Account Type"
            columnClassName="min-w-120"
          >
            Account Type
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='usageFormatted'
            dataField="usageFormatted"
            dataSort
            filter={{ type: "SelectFilter", options: AccountUsage }}
            csvHeader="Used As"
            dataAlign="center"
            columnClassName="min-w-120"
          >
            Used As
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='createdOnFormatted'
            dataField="createdOnFormatted"
            dataAlign="center"
            dataSort
            sortFunc={(a, b, order) => sortDate(a.createdOn, b.createdOn, order)}
            filter={{ type: "DateFilter", delay: 1000 }}
            csvHeader="Created On"
            columnClassName='text-xs'
            width="140"
          >
            Created On
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='disabled'
            dataField="disabled"
            dataAlign="center"
            dataSort
            tdStyle={{ verticalAlign: 'middle' }}
            dataFormat={value => value ? <FontAwesome style={{ color: 'green' }} name='check' /> : ''}
            filter={{ type: "SelectFilter", options: BooleanStatuses }}
            csvHeader="Disabled"
            width="90"
          >
            Disabled
          </TableHeaderColumn>

          <TableHeaderColumn
            dataAlign="center"
            width="80px"
            dataFormat={(_, row) =>
            <span className="flex-detail">
              <Link to={`/glaccounts/${row.id}/detail`} className='p-5'>
                <FontAwesome name="eye" title='View' />
              </Link>
              { this.renderUpdateLink(row.id) }
            </span>
            }
          />
        </SingleSelectTable>

        <AlertModal
          show={ glAccount != null }
          title="Confirm deletion"
          body={ this.renderDeletionConfirmContent() }
          bsStyle="danger"
          close={ this.closeDeleteForm }
          confirm={ this.confirmDelete }
          proceedText="Delete"
          disabled={ running }
        />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const glAccounts = DckSelectors.selectAllItems(state, ItemTypes.GLAccount)
  return { glAccounts }
},

mapDispatchToProps = dispatch => ({
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.GLAccount)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListGLAccount)



// WEBPACK FOOTER //
// ./src/components/Accounting/GLAccounts/List.js